import React from 'react';
import { useTranslation } from 'react-i18next';
import { PreviewSection, type PreviewMode } from '@nordinsight/implant-core/ui';
import type { RegionalInfo } from '../../../store/implant-context';
import {
    buildImplantPreviewSections,
    type ImplantPreviewInput,
} from './implantPreviewData';

interface ImplantPreviewContentProps {
    info: any;
    regionalInfo: RegionalInfo;
    conditionals: any;
    approvalInfo?: any;
    departmentNotes?: any[];
    mode: PreviewMode;
    plainText?: string;
}

export function ImplantPreviewContent({
    info,
    regionalInfo,
    conditionals,
    approvalInfo,
    departmentNotes,
    mode,
    plainText,
}: ImplantPreviewContentProps) {
    const { t } = useTranslation();

    if (mode === 'copy') {
        return (
            <pre className="whitespace-pre-wrap font-mono text-sm leading-relaxed p-4">
                {plainText}
            </pre>
        );
    }

    const input: ImplantPreviewInput = {
        info,
        regionalInfo,
        conditionals,
        approvalInfo,
        departmentNotes,
    };
    const sections = buildImplantPreviewSections(input, t);

    if (sections.length === 0) {
        return null;
    }

    return (
        <>
            {sections.map((section) => (
                <PreviewSection key={section.key} data={section} />
            ))}
        </>
    );
}
